import type { RouteObject } from 'react-router-dom';
import { contestRoutes } from './contest.routes';
import { dashboardRoutes } from './dashboard.routes';
import { fullScreenRoutes } from './fullScreen.routes';
import { guestRoutes } from './guest.routes';
import { mainSectionRoutes } from './mainSection.routes';
import { programRoutes } from './program.routes';

export const guestRouteModules: RouteObject[] = [guestRoutes];

export const appRouteModules: RouteObject[] = [dashboardRoutes, mainSectionRoutes, contestRoutes, programRoutes];

export const fullScreenRouteModules: RouteObject[] = fullScreenRoutes;
